import { attempt as s } from "./contact-channels54.js";
import { NRLogger as a } from "./contact-channels45.js";
const p = async (o, n) => {
  const e = new URLSearchParams();
  e.append("tenant", o), e.append("locale", n), e.append("segment", "Regular");
  const { data: r, error: t } = await s(
    fetch(`https://global-channel-provider-service.care.vpsvc.com/v3/channels/phone?${e}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": "Dz70ypBT7D1xRxqCCcUn71qH8iZ9qRiO3Ndbx2YU"
      }
    })
  );
  if (t)
    throw a.error("Contact Channels: Phone Schedule", {
      ...t,
      locale: n,
      tenant: o
    }), new Error(`Network error: ${t}`);
  if (!r.ok)
    throw a.error("Contact Channels: Phone Schedule", {
      status: r.status,
      message: "Failed to fetch Phone Schedule"
    }), new Error(`HTTP error! Status: ${r.status}`);
  return r.json();
};
export {
  p as getPhoneSchedule
};
//# sourceMappingURL=contact-channels46.js.map
